import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";

class GetActivitiesSectorListAction extends BaseAction<void, void> {
    override async run(): Promise<any> {
        let activitiesSectors: any = []
        try {
            if (this.result == null) {
                activitiesSectors = [
                    {
                        id: 1,
                        value: "construction_and_real_estate",
                        label: "Construction & Real Estate",
                        labelTranslationKey: "constructionAndRealEstate"
                    },
                    {
                        id: 2,
                        value: "hospitality_and_tourism",
                        label: "Hospitality & Tourism",
                        labelTranslationKey: "hospitalityAndTourism"
                    },
                    {
                        id: 3,
                        value: "financial_services",
                        label: "Financial Services",
                        labelTranslationKey: "financialServices"
                    },
                    {
                        id: 4,
                        value: "oil_and_gas",
                        label: "Oil & Gas",
                        labelTranslationKey: "oilAndGas"
                    },
                    {
                        id: 5,
                        value: "technology_and_innovation",
                        label: "Technology & Innovation",
                        labelTranslationKey: "technologyAndInnovation"
                    },
                    {
                        id: 6,
                        value: "healthcare",
                        label: "Healthcare",
                        labelTranslationKey: "healthcare"
                    },
                    {
                        id: 7,
                        value: "e_commerce",
                        label: "E-commerce",
                        labelTranslationKey: "eCommerce"
                    },
                    {
                        id: 8,
                        value: "general_trading",
                        label: "General Trading",
                        labelTranslationKey: "generalTrading"
                    },
                    {
                        id: 10,
                        value: "manufacturing",
                        label: "Manufacturing",
                        labelTranslationKey: "manufacturing"
                    },
                    {
                        id: 11,
                        value: "professional_services",
                        label: "Professional Services",
                        labelTranslationKey: "professionalServices"
                    },
                    {
                        id: 12,
                        value: "education_and_training",
                        label: "Education & Training",
                        labelTranslationKey: "educationAndTraining"
                    },
                    {
                        id: 13,
                        value: "logistics",
                        label: "Logistics",
                        labelTranslationKey: "logistics"
                    },
                    {
                        id: 14,
                        value: "media_and_entertainment",
                        label: "Media & Entertainment",
                        labelTranslationKey: "mediaAndEntertainment"
                    }
                ]
                updateRecoilState("activitiesSectorsAtom", activitiesSectors)
            }
        } catch (error: any) {
            console.error("Error fetching Activities Sectors :", error);
        }
        finally {
            return activitiesSectors
        }
    }
}

export const getActivitiesSectorListAction = new GetActivitiesSectorListAction()


